import styles from './PageSkeleton.module.css';
import { Skeleton } from './Skeleton.tsx';

/** Outline of a page while its code or first data loads: a shape, not a spinner. */
export const PageSkeleton = () => (
  <div className={styles.page} aria-busy="true">
    <Skeleton shape="title" width="30%" />
    <Skeleton shape="text" width="55%" />
    <div className={styles.block}>
      <Skeleton shape="block" />
    </div>
  </div>
);
